/* global module clearTimeout setTimeout*/

import React, { Component } from 'react';
import { round, get, has, pick } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cx from 'classnames';
import numericInput from '../../../../lib/numericInput';
import s from '../../../../redux/selectors';
import a from '../../../../redux/actions';
import { withT, wrap } from '../../../../lib/wrappers';
import actionHelpers from '../../../../lib/actions';
import customDetails from './CustomDetails';
import { userPledgeStatus } from '../../../../lib/userApi';
import { CustomizableTr } from '../../../common/Customizable';

class ActionComponent extends Component {

  constructor(props, context) {
    super(props, context);
    const action = this;
    action.state = {
      key: this.props.action_key,
      category: this.props.category,
      detailed: false,
    };
  }

  componentDidMount() {
    if (this.category === 'transportation') this.selectVehicle(1, this.key);
  }

  setInputState(id) {
    return this.userApiValue(id);
  }

  setSelectOptions(select) {
    if (select.type === 'vehicle') {
      return this.props.vehicles
        .map(vehicle => ({
          value: vehicle.index,
          text: `Vehicle ${vehicle.index}`,
        }));
    }
    return select.options;
  }

  getSelectedOption(id) {
    const is_vehicle = id.lastIndexOf('vehicle_select');
    const key = this.state.key;
    let mpg;

    if (is_vehicle > 0) {
      if (key === 'ride_my_bike' || key === 'telecommute_to_work' || key === 'take_public_transportation') {
        mpg = get(this.props.user_footprint, `compute_takeaction_results.input_takeaction_${key}_mpg`);
      } else {
        mpg = get(this.props.user_footprint, `compute_takeaction_results.input_takeaction_${key}_mpg_old`);
      }

      for (let i = 1; i <= 10; i += 1) {
        const fp_mpg = get(this.props.user_footprint, `compute_footprint.input_footprint_transportation_mpg${i}`);
        if (fp_mpg === mpg) {
          return i;
        }
      }
    }
    return this.userApiValue(id);
  }

  toggleActionDetails() {
    this.setState({ detailed: !this.state.detailed });
  }

  displayStateValue({ show, suffix, decimals, prefix }) {
    let state_id = show;
    if (state_id.includes('display_takeaction')) {
      state_id = state_id.replace(/display_takeaction/i, 'input_takeaction');
    }
    let value = this.userApiValue(state_id);
    if (decimals || decimals === 0) value = round(value, decimals);
    if (value !== null && !isNaN(value)) value = numericInput.format(value, { autoDecimal: true });
    if (!suffix) {
      return `${prefix || ''}${value}`;
    }
    return `${prefix || ''}${value} ${suffix}`;
  }

  updateActionInput(event) {
    const action = this;
    const val = event.target.value;
    const id = event.target.id;
    const update = {};

    update[id] = val;
    update.input_changed = id;
    action.setState(update);
    this.props.computeTakeActionResults({ [id]: val });
  }

  handleChange(event) {
    const i = event.target.value;
    const is_vehicle = event.target.id.lastIndexOf('vehicle_select');
    const action_key = event.target.dataset.action_key;
    const id = event.target.id;

    if (is_vehicle > 0) {
      this.selectVehicle(i, action_key);
    } else {
      const update = {};
      update[id] = i;
      this.setState(update);
      this.props.computeTakeActionResults(update);
    }
  }

  get t() {
    return this.props.t;
  }

  selectVehicle(i, action_key) {
    const v_miles = get(this.props.user_footprint, `compute_footprint.input_footprint_transportation_miles${i}`);
    const v_mpg = get(this.props.user_footprint, `compute_footprint.input_footprint_transportation_mpg${i}`);
    const update = {};

    if (action_key === 'ride_my_bike' || action_key === 'telecommute_to_work' || action_key === 'take_public_transportation') {
      update[`input_takeaction_${action_key}_mpg`] = parseInt(v_mpg, 10);
      this.setState(update);
      this.props.computeTakeActionResults(update);
    } else {
      update[`input_takeaction_${action_key}_mpg_old`] = parseInt(v_mpg, 10);
      update[`input_takeaction_${action_key}_miles_old`] = parseInt(v_miles, 10);
      this.setState(update);
      this.props.computeTakeActionResults(update);
    }
  }

  userApiValue(apiKey) {
    const userFootprint = this.props.user_footprint;
    let value;
    if (/input_/.test(apiKey)) {
      value = get(userFootprint, `inputs.${apiKey}`);
      if (!value && value !== '') value = get(this.props.average_footprint, `get_defaults_and_results.${apiKey}`);
    } else if (/result_takeaction/.test(apiKey)) {
      value = get(userFootprint, `compute_takeaction_results.${apiKey}`);
    } else {
      value = get(userFootprint, `compute_footprint.${apiKey}`);
    }
    return numericInput.format(value, { autoDecimal: true });
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  get api_key() {
    return `input_takeaction_${this.state.key}`;
  }

  get result_key() {
    return `result_takeaction_${this.state.key}`;
  }

  get display_name() {
    return actionHelpers.getLabel(this.state.key, this.t);
  }

  get is_shown_detailed() {
    return this.state.detailed;
  }

  // These values come from translations.
  displayAssumptionDescription(assumption) {
    if (assumption.show) {
      return `${assumption.description} ${this.displayStateValue(assumption)}`;
    }
    return assumption.description;
  }

  get tons_saved() {
    const { resultTakeActionTons } = this.props;
    const { key } = this.state;
    return numericInput.format(resultTakeActionTons[key], { decimalPlaces: 1 });
  }

  get dollars_saved() {
    const { resultTakeActionDollars } = this.props;
    const { key } = this.state;
    return numericInput.format(resultTakeActionDollars[key]);
  }

  get upfront_cost() {
    const { resultTakeActionNet10Yr } = this.props;
    const { key } = this.state;
    return numericInput.format(round(resultTakeActionNet10Yr[key]));
  }

  /**
   * Status
   */

  get pledged() {
    const { pledges } = this.props;
    return pledges[this.state.key] === userPledgeStatus.PLEDGED;
  }

  get completed() {
    const { pledges } = this.props;
    return pledges[this.state.key] === userPledgeStatus.COMPLETED;
  }

  get not_relevant() {
    const { pledges } = this.props;
    return pledges[this.state.key] === userPledgeStatus.NOT_RELEVANT;
  }

  get no_status() {
    const { pledges } = this.props;
    return !has(pledges, this.state.key);
  }

  get relevance() {
    if (this.not_relevant) {
      return this.not_relevant;
    }
    return '';
  }

  get status_text() {
    if (this.completed) {
      return this.t('Complete');
    } else if (this.pledged) {
      return this.t('Pledged');
    } else if (this.not_relevant) {
      return this.t('Not relevant');
    }
    return this.t('Select');
  }

  get vehicles_loaded() {
    return has(this.props.ui, 'vehicles');
  }

  get hasCustomDetails() {
    return customDetails.has(this.state.key);
  }

  get customDetails() {
    const Details = customDetails.get(this.state.key);
    return React.createElement(Details);
  }


  render() {
    const { updateActionStatus, ui } = this.props;
    return (
      <tbody
        id={`action__${this.api_key}`}
        className="action"
        /* These data attributes are for integration tests. */
        data-position={this.props.position}
        data-category={this.props.category}
        data-status={this.props.pledges[this.state.key]}
        data-tons_saved={this.tons_saved}
        data-dollars_saved={this.props.resultTakeActionDollars[this.state.key]}
        data-upfront_cost={this.props.resultTakeActionNet10Yr[this.state.key]}
      >
        {!this.props.is_assumption &&
          <CustomizableTr
            ui={ui}
            active="action__heading--pledged"
            className={cx('action', { 'action__heading--completed': this.completed, 'action__heading--pledged': this.pledged, 'action__heading--not_relevant': this.not_relevant })}
          >
            <td
              id={`action__detail_toggle__${this.api_key}`}
              onClick={e => this.toggleActionDetails(e)}
            >
              <i
                className={cx('fa', { 'fa-chevron-down': !this.is_shown_detailed, 'fa-chevron-up': this.is_shown_detailed })}
              />
            </td>
            <td className="action__title">{this.display_name}</td>
            <td className="no-wrap action__tons_saved">{this.tons_saved}</td>
            {/* eslint-disable no-template-curly-in-string */}
            <td className="no-wrap action__dollars_saved">{this.t('${{amount}}', { amount: this.dollars_saved })}</td>
            <td className="no-wrap action__upfront_cost">{this.t('${{amount}}', { amount: this.upfront_cost })}</td>
            {/* eslint-enable no-template-curly-in-string */}
            <td className="action__status-column">
              <div className="dropdown">
                <button
                  className="btn btn-default dropdown-toggle" type="button"
                  id={`action__dropdown_toggle__${this.api_key}`}
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
                >
                  <span className="action__status-text">{this.status_text}</span>
                  <i
                    className={cx('fa', { 'fa-square-o': this.no_status, 'fa-check-square-o': this.pledged, 'fa-check-square': this.completed, 'fa-ban': this.not_relevant })}
                  />
                </button>
                <ul
                  id={`action__dropdown__${this.api_key}`}
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby={`action__dropdown_toggle__${this.api_key}`}
                >
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        updateActionStatus(this.state.key, userPledgeStatus.PLEDGED);
                      }}
                      className={`dropdown-item action__dropdown__status--${userPledgeStatus.PLEDGED}`}
                      href="#"
                    >{this.t('I pledge to do this')}</a></li>
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        updateActionStatus(this.state.key, userPledgeStatus.COMPLETED);
                      }}
                      className={`dropdown-item action__dropdown__status--${userPledgeStatus.COMPLETED}`}
                      href="#"
                    >{this.t("I've already done this")}</a></li>
                  <li role="separator" className="divider" />
                  <li>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        updateActionStatus(this.state.key, userPledgeStatus.NOT_RELEVANT);
                      }}
                      className={`dropdown-item action__dropdown__status--${userPledgeStatus.NOT_RELEVANT}`}
                      href="#"
                    >{this.t('This is not relevant to me')}</a></li>
                </ul>
              </div>
            </td>
          </CustomizableTr>
        }
        {this.vehicles_loaded && this.state.detailed &&
          <tr>
            <td colSpan="6" className="action__body" >
              {this.customDetails}
            </td>
          </tr>
        }
      </tbody>
    );
  }
}

ActionComponent.propTypes = Object.assign({}, {
  is_assumption: React.PropTypes.bool.isRequired,
  action_key: React.PropTypes.string,
  category: React.PropTypes.string,
});

const mapStateToProps = (state, ownProps) => [
  'resultTakeActionTons',
  'resultTakeActionDollars',
  'resultTakeActionNet10Yr',
  'vehicles',
  'user_footprint',
  'ui',
  'pledges',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, ['updateActionStatus', 'computeTakeActionResults']),
  dispatch,
);

export default wrap(
  withT('takeAction'),
  connect(mapStateToProps, mapDispatchToProps),
  ActionComponent,
);
